import React, { useState } from 'react';

import moment from 'moment';

import { PricingVersionSelector } from './pricing-version-selector';

import { PlanConfirmationDialogBody } from '../../admin/admin-panel/account-status-transitions/status-transition-dialogs/plan-confirmation-dialog-body';
import { UiDialog } from '../../ui/ui-dialog';

import { ItemizedPlanConfirmationDialogBody } from './subscription-v3/itemized-plan-confirmation-dialog-body';

import { ACCOUNT_STATUS } from '../../util/account-status';
import Message from '../../widgets/legacy-message';
import { PRICING_VERSION } from '../utils/pricing-version';

type InputProps = AccountStatusTransitionDialogProps & {
  isEdit?: boolean;
};

export const TrialPlanConfirmationDialogWrapper = (props: InputProps) => {
  const { account, cancelTransition } = props;

  const [selectedPricingVersionId, setSelectedPricingVersionId] = useState<number>(
    account.pricingVersionId,
  );

  return (
    <UiDialog title="Confirm Plan" onClose={cancelTransition}>
      <UiDialog.Content>
        {account.status === ACCOUNT_STATUS.TRIAL && account.trialEndDate && (
          <Message variant="warning" canBeDismissed={false} className="u-margin-bottom-lg">
            Note that the customer will be billed at the end of the trial -{' '}
            {moment.utc(account.trialEndDate).format('dddd M/D')}
          </Message>
        )}
        <PricingVersionSelector
          accountPricingVersionId={account.pricingVersionId}
          selectedPricingVersionId={selectedPricingVersionId}
          setSelectedPricingVersionId={setSelectedPricingVersionId}
        />
      </UiDialog.Content>
      {selectedPricingVersionId === PRICING_VERSION.V3 ? (
        <ItemizedPlanConfirmationDialogBody {...props} />
      ) : (
        <PlanConfirmationDialogBody {...props} />
      )}
    </UiDialog>
  );
};
